export default __webpack_public_path__ + "static/media/arrow-down.a05ef1a0.svg";